import React from 'react';
import { PricingContext } from './PricingContext.es.js';
import { Languages } from '../../constants/Languages.es.js';

var PricingProvider = function PricingProvider(_ref) {
  var children = _ref.children,
    applicationName = _ref.applicationName,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? Languages.English : _ref$language,
    authorizationToken = _ref.authorizationToken,
    env = _ref.env,
    log = _ref.log,
    locationPathname = _ref.locationPathname,
    _ref$onProductPurchas = _ref.onProductPurchase,
    onProductPurchase = _ref$onProductPurchas === void 0 ? function () {
      return undefined;
    } : _ref$onProductPurchas,
    _ref$onSubscriptionPu = _ref.onSubscriptionPurchase,
    onSubscriptionPurchase = _ref$onSubscriptionPu === void 0 ? function () {
      return undefined;
    } : _ref$onSubscriptionPu,
    _ref$onSignUp = _ref.onSignUp,
    onSignUp = _ref$onSignUp === void 0 ? function () {
      return undefined;
    } : _ref$onSignUp,
    _ref$showMasteringSta = _ref.showMasteringStandardPluginOffer,
    showMasteringStandardPluginOffer = _ref$showMasteringSta === void 0 ? false : _ref$showMasteringSta,
    _ref$isStudioEssentia = _ref.isStudioEssentialsEnabled,
    isStudioEssentialsEnabled = _ref$isStudioEssentia === void 0 ? false : _ref$isStudioEssentia,
    _ref$isStudioEssentia2 = _ref.isStudioEssentialsWithFlavorEnabled,
    isStudioEssentialsWithFlavorEnabled = _ref$isStudioEssentia2 === void 0 ? false : _ref$isStudioEssentia2,
    _ref$showMasteringSta2 = _ref.showMasteringStandardALC,
    showMasteringStandardALC = _ref$showMasteringSta2 === void 0 ? false : _ref$showMasteringSta2,
    _ref$showLandrUltimat = _ref.showLandrUltimateBundle,
    showLandrUltimateBundle = _ref$showLandrUltimat === void 0 ? false : _ref$showLandrUltimat,
    _ref$showLandrSynthXP = _ref.showLandrSynthXPlugin,
    showLandrSynthXPlugin = _ref$showLandrSynthXP === void 0 ? false : _ref$showLandrSynthXP;
  return /*#__PURE__*/React.createElement(PricingContext.Provider, {
    value: {
      applicationName: applicationName,
      authorizationToken: authorizationToken,
      env: env,
      log: log,
      language: language,
      locationPathname: locationPathname,
      onProductPurchase: onProductPurchase,
      onSubscriptionPurchase: onSubscriptionPurchase,
      onSignUp: onSignUp,
      showMasteringStandardPluginOffer: showMasteringStandardPluginOffer,
      isStudioEssentialsEnabled: isStudioEssentialsEnabled,
      isStudioEssentialsWithFlavorEnabled: isStudioEssentialsWithFlavorEnabled,
      showMasteringStandardALC: showMasteringStandardALC,
      showLandrUltimateBundle: showLandrUltimateBundle,
      showLandrSynthXPlugin: showLandrSynthXPlugin
    }
  }, children);
};

export { PricingProvider };
